module.exports = __webpack_public_path__ + "img/pwa.2b15c979.svg";